namespace $.$$ {

	export class $shm_hitalama_vk_token_switch extends $.$shm_hitalama_vk_token_switch {

		@ $mol_mem
		vk_redirect_uri() {
			const { origin, pathname } = $.$mol_dom_context.document?.location
			return origin + pathname
		}

		@ $mol_mem
		tokens() {
			return this.$.$shm_hitalama_profile.current()?.Tokens()?.remote_list() ?? []
		}

		clear() {
			this.current_link('')
			this.$.$shm_hitalama_profile.current()?.Tokens()?.remote_list( [] )
		}

		@ $mol_mem
		current() {
			const id = this.current_link()
			return id ? this.token( id ) : null
		}

		@ $mol_mem
		current_link( next?: string ): string {
			if( next === undefined ) {
				const tokens = this.tokens()
				const ref = $mol_state_local.value<string>( '$' + 'hitalama_vk_token_switch.current_link()' )!
				return tokens.find( t => t.link().toString() == ref ) ? ref : ''
			}
			return $mol_state_local.value( '$' + 'hitalama_vk_token_switch.current_link()', next ) || ''
		}

		@ $mol_mem_key
		token( ref_str: string ) {
			return this.$.$giper_baza_glob!.Pawn( new $giper_baza_link( ref_str ), $shm_hitalama_vk_token )
		}

		@ $mol_mem
		tokens_links() {
			return this.tokens().map( t => t.link().toString() ) ?? []
		}
		
		@ $mol_mem
		tokens_view() {
			return this.tokens_links().map( ref => this.Token( ref ) )
		}

		@ $mol_action
		vk_get_user( token: $shm_hitalama_vk_token, token_str: string, user_id: string ){
			const code = 'return API.users.get({"user_ids":"'+ user_id + '","fields":"photo_50"});'
			$shm_hitalama_vk_jsonp.vk_execute( token_str, code, this.vk_user_receive, token )
		}

		@ $mol_action
		vk_user_receive( res: any, token: $shm_hitalama_vk_token ){
			const photo_url = res.response[0].photo_50
			token.Avatar_url(null)?.val( photo_url )
		}

		@ $mol_mem
		vk_token_url_parse() {
			const params = new URLSearchParams( this.$.$mol_state_arg.value('access_token') || '' )

			const token_str = params.keys().next().value
			if( !token_str ) return ''

			const user_id = params.get('user_id')!

			const token = this.$.$shm_hitalama_profile.current()?.Tokens(null)?.make( null )!
			token?.Token(null)?.val( token_str )
			token?.User_id(null)?.val( user_id )

			this.$.$mol_state_arg.value('access_token', null)
			
			this.vk_get_user( token, token_str, user_id )

			this.current_link( token.link().toString() )

			return token_str
		}

		@ $mol_mem
		vk_user_id() {
			const params = new URLSearchParams( this.$.$mol_state_arg.value('access_token') || '' )
			return params.get('user_id')
		}

		vk_auth_uri(): string {
			return 'https://oauth.vk.com/authorize?client_id=' + this.vk_client_id() +
				'&display=popup&redirect_uri=' + 
				this.vk_redirect_uri() + 
				'&scope=groups,wall,offline&response_type=token&v=5.131'
		}
		
	}

}
